export { hasSomeRole, realmRoles, userFullname } from '@medcom/shared-ui/utils/user.ts';

import { hasRealmRole, hasSomeRole } from '@medcom/shared-ui/utils/user.ts';
import type { User } from 'oidc-client-ts';

export enum Role {
  ROLE_LR_MEDCOM = 'ROLE_LR_MEDCOM',
  ROLE_LR_LAB_ADMIN = 'ROLE_LR_LAB_ADMIN',
  ROLE_LR_USER = 'ROLE_LR_USER',
  ROLE_LR_LAB_STAFF = 'ROLE_LR_LAB_STAFF',
  ROLE_LR_FRONT_DESK = 'ROLE_LR_FRONT_DESK',
}

export const hasAnyRelevantRole = (user: User | null | undefined): boolean => !!user && Object.keys(Role).some(r => hasRealmRole(user, r));

export const hasFrontDeskRole = (user: User | undefined | null) => hasSomeRole([Role.ROLE_LR_FRONT_DESK], user);

export const translateRole = (role: Role | string) => {
  switch (role) {
    case Role.ROLE_LR_MEDCOM:
      return 'Medcom Administrator';
    case Role.ROLE_LR_LAB_ADMIN:
      return 'Labor Administrator';
    case Role.ROLE_LR_USER:
      return 'Zuweiser';
    case Role.ROLE_LR_LAB_STAFF:
      return 'Labor Mitarbeiter';
    case Role.ROLE_LR_FRONT_DESK:
      return 'Labor Patientenverkehr';
    default:
      return 'Unbekannte Rolle';
  }
};
